// Shipments can share one OMBL only when they sail the same route: identical
// POL and identical POD (vessel details of the shipment). The backend enforces
// the same rule when an OMBL is saved; these helpers give the user the answer
// immediately, before anything is sent.

const normalize = (value) =>
    String(value ?? "")
        .trim()
        .replace(/\s+/g, " ")
        .toLocaleLowerCase("tr-TR");

const placeKey = (place) => `${normalize(place?.port)}|${normalize(place?.country)}`;

const placeText = (place) => {
    const text = [place?.port, place?.country]
        .map((part) => String(part ?? "").trim())
        .filter(Boolean)
        .join(", ");

    return text || "not set";
};

export const routeKeyOf = (attributes) =>
    `${placeKey(attributes?.vesselPol)} > ${placeKey(attributes?.vesselPod)}`;

export const describeRoute = (attributes) =>
    `POL ${placeText(attributes?.vesselPol)} -> POD ${placeText(attributes?.vesselPod)}`;

export const sameRoute = (a, b) => routeKeyOf(a) === routeKeyOf(b);
